import { observer } from 'mobx-react-lite';
import logo from '../../assets/images/logo_red.png';
import imgHeader from '../../assets/images/img-header-home.webp';
import phoneIc from '../../assets/images/phone.png';
import emailIc from '../../assets/images/email.png';
import { Button } from '@/components/common/Button';
import googleIc from '../../assets/images/google-icon.png';
import driveIc from '../../assets/images/drive-icon.png';
import notiIc from '../../assets/images/noti-icon.png';
import imgHome from '../../assets/images/img-home.webp';
import imgHome2 from '../../assets/images/img-home2.webp';
import { t } from 'i18next';
import { ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/configs/constants';
import { motion } from 'framer-motion';
import { useStore } from '@/hooks/useStore';

export default observer(function StartPage() {
    const navigate = useNavigate();
    const {
        modalStore: { showErrorModal, hideModal }
    } = useStore();

    const handleClickEmail = () => {
        window.location.href = 'mailto:info@prop.consulting';
    };

    const handleClickPhone = () => {
        window.location.href = 'tel:079-287-8320';
    };

    const handleStarted = () => {
        navigate(ROUTES.login.href);
    };

    const handleContact = () => {
        showErrorModal({
            id: 'modal-register',
            showCloseIcon: true,
            cancelButton: false,
            saveButton: false,
            closeWhenOutside: true,
            title: t('text.register2'),
            content: (
                <div>
                    <div className='pt-3 text-base text-left'>
                        <p>オンラインポストのサービスをご利用いただくためには、お手数をおかけいたしますが、まずは利用申し込みフォームにご入力をお願いいたします。</p>
                        <p className='mt-2 '>「OK」ボタンを押下されますと、オンラインポスト利用申し込みフォームへ移動いたします。</p>
                    </div>
                    <div className='mt-5 flex justify-end'>
                        <Button
                            variant='outline'
                            onClick={() => {
                                hideModal('modal-register');
                                window.open('https://docs.google.com/forms/d/1aEHH5YdZUENsRGFXW3DurogezDuFrQ1huBD4QovvIuI', '_blank');
                            }}
                            className='w-[120px] bg-main h-[39px] text-white'
                        >
                            OK
                        </Button>
                    </div>
                </div>
            )
        });
    };

    return (
        <motion.div
            className='font-sans text-[#4E4E4E]'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
        >
            <motion.header
                className='fixed top-0 left-0 w-full z-50 bg-white text-[#333] py-4 px-4 md:px-20 xl:px-[300px] flex flex-col md:flex-row justify-between items-center gap-4 shadow-md'
                initial={{ y: -50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
            >
                <div className='flex items-center justify-center md:justify-start w-full md:w-auto'>
                    <img src={logo} alt='logo' className='h-[40px] md:h-[57px] w-auto max-w-[200px] md:max-w-[366px]' />
                </div>

                <div className='flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 w-full md:w-auto'>
                    <Button
                        onClick={handleContact}
                        className='w-full sm:w-[180px] md:w-[300px] h-[50px] text-base md:text-xl font-semibold bg-white border-main border-[1px] text-main hover:bg-main hover:text-white flex justify-center items-center gap-2'
                    >
                        {t('text.register')}
                        <ChevronRight size={26} />
                    </Button>

                    <Button
                        onClick={handleStarted}
                        variant='active'
                        className='w-full sm:w-[180px] md:w-[220px] h-[50px] text-base md:text-xl font-semibold hover:bg-red-700 flex justify-center items-center gap-2'
                    >
                        {t('text.login')}
                        <ChevronRight size={26} />
                    </Button>
                </div>
            </motion.header>

            <motion.section
                className='pt-[240px] md:pt-[100px] pb-4 bg-header-home text-white text-center px-4 md:px-20 xl:px-[300px] flex flex-col md:flex-row justify-between items-center gap-6'
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.7 }}
            >
                <motion.div className='space-y-8 flex flex-col justify-center text-center md:text-left'>
                    <h2 className='text-[28px] sm:text-[36px] md:text-[48px] font-bold mb-2 text-center'>オンラインポスト</h2>
                    <p className='text-[20px] sm:text-[24px] md:text-[32px] truncate  text-center'>郵便物をオンラインで配布するサービス</p>
                    <div className='flex flex-col sm:flex-row justify-center md:justify-start items-center gap-4 mt-4 text-lg md:text-2xl'>
                        <div onClick={handleClickPhone} className='flex items-center space-x-2 cursor-pointer min-w-[200px] px-4 py-2 rounded-md hover:underline'>
                            <img src={phoneIc} alt='phone' className='w-[24px] h-[24px]' />
                            <span>079-287-8320</span>
                        </div>
                        <div onClick={handleClickEmail} className='flex items-center space-x-2 cursor-pointer px-4 py-2 hover:underline'>
                            <img src={emailIc} alt='email' className='w-[24px] h-[24px]' />
                            <span>info@prop.consulting</span>
                        </div>
                    </div>
                </motion.div>
                <motion.img
                    src={imgHeader}
                    alt='imgHeader'
                    className='w-full max-w-[444px] h-auto'
                    initial={{ scale: 0.9, opacity: 0 }}
                    whileInView={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.5 }}
                />
            </motion.section>

            <motion.section className='py-10 px-4 md:px-20 xl:px-[300px] mx-auto text-center' initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.5 }}>
                <h3 className='text-[24px] sm:text-[28px] md:text-[36px] font-bold mb-4 text-[#1A1A1A]'>アプリの説明</h3>
                <p className='mb-10 text-sm sm:text-base md:text-lg'>
                    「オンラインポスト」は、事業者の皆様が請求書管理を効率的に行えるよう支援し、
                    <br className='hidden md:inline' />
                    新しい請求書が発行された際に、利用者様へ自動でお知らせするアプリケーションです。
                    <br className='hidden md:inline' />
                    主な機能は以下の通りです。
                </p>
                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10'>
                    {[
                        { src: googleIc, title: 'Google ログイン', text: 'Google認証を利用することで、高いセキュリティと利便性を実現し、管理者様がシステムへ容易にアクセスできるようにします。' },
                        { src: driveIc, title: '請求書のアップロードと保存', text: '請求書はGoogleドライブへ直接アップロードされるため、安全に保管され、いつでも簡単に検索可能です。' },
                        { src: notiIc, title: '自動通知', text: '新しい請求書が更新されると、利用者様へ速やかに通知が届き、迅速かつ透明性の高い財務管理をサポートします。' }
                    ].map((item, idx) => (
                        <motion.div key={idx} className='flex flex-col items-center text-center'>
                            <img src={item.src} alt={item.title} className='w-16 h-16 md:w-20 md:h-20' />
                            <h4 className='font-semibold mt-2 text-[#1A1A1A] text-xl md:text-2xl'>{item.title}</h4>
                            <p className='text-sm sm:text-base mt-1'>{item.text}</p>
                        </motion.div>
                    ))}
                </div>
            </motion.section>

            <motion.section className='bg-gray-50 py-10 px-4 md:px-20 xl:px-[300px]'>
                <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
                    <h3 className='text-[24px] sm:text-[28px] md:text-[36px] font-bold text-center mb-4 text-[#1A1A1A]'>お客様のGoogleデータへのアクセスが必要な理由</h3>
                    <p className='text-center mb-8 text-sm sm:text-base md:text-lg'>
                        安全で便利、かつ効率的なユーザー体験を提供するために、Google認証とGoogleドライブへのアクセスをお願いしております。
                    </p>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
                        {[{
                            img: imgHome2,
                            label: 'Google ログイン',
                            desc: '管理者様の認証に Google OAuthを使用することで、お客様は個別のパスワードを作成することなく、安全かつ迅速にログインできます。'
                        },
                        {
                            img: imgHome,
                            label: '請求書のアップロードと保存',
                            desc: '請求書をお客様のGoogleドライブへ直接保存することで、効率的な管理、プライバシーとセキュリティの確保、および必要な際の迅速な検索が可能となります。'
                        }].map((item, idx) => (
                            <div className='bg-white rounded shadow overflow-hidden' key={idx}>
                                <motion.div className='overflow-hidden' whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
                                    <img src={item.img} alt={item.label} className='w-full h-[50vw] sm:h-[40vw] md:h-[20vw] object-cover' />
                                </motion.div>
                                <div className='relative'>
                                    <div className='bg-white flex justify-start absolute -top-5 left-[2px] p-[2px] rounded-3xl rounded-bl-none'>
                                        <div className='bg-main flex justify-start px-4 py-[10px] rounded-3xl rounded-bl-none text-white'>
                                            {item.label}
                                        </div>
                                    </div>
                                    <p className='text-sm sm:text-base md:text-lg font-light pt-8 pb-3 px-4'>{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <p className='text-sm sm:text-base md:text-lg text-left mt-8 font-light'>
                        ※透明性への取り組み：お客様のGoogleデータへのアクセスは、上記の機能提供のみを目的としており、第三者と共有することは一切ございません。
                        お客様のプライバシーとセキュリティを最優先に考慮し、開発を進めております。
                    </p>

                    <div className='flex justify-center mt-6'>
                        <Button onClick={handleStarted} variant='active' className='w-[200px] h-[50px] text-base md:text-xl font-semibold hover:bg-red-700'>
                            {t('text.login')}
                            <ChevronRight size={26} />
                        </Button>
                    </div>
                </motion.div>
            </motion.section>

            <div className='text-lg text-white text-center py-4 bg-[#596164] px-4 md:px-20 flex flex-col md:flex-row justify-around items-center gap-2'>
                <a className='hover:underline' href='https://cms.onlinepost.jp/policy.html'>{t('text.privacy_policy')}</a>
                <p>
                    メールアドレス：
                    <span onClick={handleClickEmail} className='cursor-pointer hover:underline'>info@prop.consulting</span>
                    {' ・ '}
                    電話番号：
                    <span onClick={handleClickPhone} className='cursor-pointer hover:underline'>079-287-8320</span>
                </p>
            </div>
        </motion.div>
    );
});
